import script from "./normal.vue?vue&type=script&lang=ts&setup=true"
export * from "./normal.vue?vue&type=script&lang=ts&setup=true"

import "./normal.vue?vue&type=style&index=0&id=4d901828&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\WebStorm\\operation-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d901828"]])

export default __exports__